import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SERVER } from '../../../config';
import {
    SIGNUP,
    signUpSuccess,
    signUpFailure
} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from "../../../components/Utils/httpHelper";

export function* rubixSignUp(action) {
    let requestURL = `${AUTH_SERVER}/user/analyst/signup`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(signUpSuccess(result.data));
    } catch (err) {
        yield put(signUpFailure(err))
    }
}
export function* signUp() {
    yield takeLatest(SIGNUP, rubixSignUp);
}
